import { FC } from 'react';

import { Panel } from '../PanelLayout';
import { PanelTemplateProps } from '../types';

const SecondaryPanel: FC<PanelTemplateProps> = ({
  children,
  testMetadata,
  ...otherProps
}) => {
  return (
    <Panel name="secondary" {...otherProps} {...testMetadata}>
      {children}
    </Panel>
  );
};

export default SecondaryPanel;
